var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-upgrade"},[_vm._v(" 版本升级 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }